import React from 'react'
import { map, pipe, split, toPairs, toString } from 'lodash/fp'

/**
 * Used to render font in a monospaced manner for a better visual effect.
 *
 * @param {number} number - value to be converted into monospaced JSX.
 * @param {string} className - CSS class tp be applied to each char.
 *
 * @returns {Object} JSX representation of the same number.
 *
 * @example
 * numberToMonospacedJsx(67, 'class)
 * // => [<span className="class">6</span>, <span className="class">7</span>]
 */
export default (number: number, className: string) =>
  pipe(
    toString,
    split(''),
    toPairs,
    map(([index, char]) => (
      <span key={index} className={className}>
        {char}
      </span>
    )),
  )(number)
